import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@brighterion/br-ui';
import styles from './styles.css';

interface Props {
    closeModal(): void;
}

const NothingToDeployModal = ({ closeModal }: Props) => {
    const { t } = useTranslation();
    return (
        <>
            <Modal.Title
                id='deploy-modal-title'
                title={t('No Deployment')}
                onClose={closeModal}
                showCloseIcon={false}
                statusIcon='warning'
            />
            <div className={styles.nothingToDeploy} data-testid='nothing-to-deploy'>
                {t('There are no changes to deploy')}
            </div>
            <Modal.Footer id='deploy-footer' onClose={closeModal} onCloseText={t('Close')} />
        </>
    );
};

export default React.memo(NothingToDeployModal);
